import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot instead of render
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import App from "./layouts/App";
import axios from "axios";
import { PersistGate } from "redux-persist/integration/react";

axios.defaults.headers.common["blId"] = sessionStorage.getItem("blId");

const root = createRoot(document.getElementById("root")); // Use createRoot

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </BrowserRouter>
);

if (module.hot) {
  module.hot.accept();
}
